// extracted by mini-css-extract-plugin
export default {"mediaBody":"dtOopqk0NvHM4D3uvgMo"};